import { computed, watch } from "vue";
import store from "@/store";
import { updatePrimaryPalette } from "@primeuix/styled";
import { appliquerManifestePwa } from "@/core/services/ManifestePwaService";

export const societePalettes: Record<string, Record<number, string>> = {
  "BALLEYDIER 4X4": {
    50: "#FFF6DE",
    100: "#FFF0C9",
    200: "#FFE4A0",
    300: "#FFD978",
    400: "#FFCD4F",
    500: "#FFC226",
    600: "#EDAA00",
    700: "#B58200",
    800: "#7D5A00",
    900: "#453100",
    950: "#291D00",
  },
  "JUGAND AUTOS": {
    50: "#FFCBB8",
    100: "#FFBCA3",
    200: "#FF9E7A",
    300: "#FF8052",
    400: "#FF6229",
    500: "#FF4400",
    600: "#C73500",
    700: "#8F2600",
    800: "#571700",
    900: "#1F0800",
    950: "#030100",
  },
  "AUTO EVASION": {
    50: "#fef2f3",
    100: "#ffe1e2",
    200: "#ffc8ca",
    300: "#ffa2a6",
    400: "#fc6d73",
    500: "#f53e46",
    600: "#e43038",
    700: "#be171e",
    800: "#9d171d",
    900: "#821a1f",
    950: "#47080b",
  },
  "POLARIS MONT-BLANC": {
    50: "#eff7ff",
    100: "#deeeff",
    200: "#b6ddff",
    300: "#76c3ff",
    400: "#2da5ff",
    500: "#0289f5",
    600: "#006bd2",
    700: "#0055aa",
    800: "#004e97",
    900: "#073d73",
    950: "#04264d",
  },
  "BOGEY UTILITAIRES": {
    50: "#fff2f1",
    100: "#ffe1df",
    200: "#ffc8c5",
    300: "#ffa29d",
    400: "#ff6d65",
    500: "#ff3e34",
    600: "#ee2e24",
    700: "#c8160d",
    800: "#a5160f",
    900: "#881a14",
    950: "#4a0805",
  },
};

export const societeContrastColors: Record<string, string> = {
  "BALLEYDIER 4X4": "#000000",
  "JUGAND AUTOS": "#FFFFFF",
  "AUTO EVASION": "#FFFFFF",
  "POLARIS MONT-BLANC": "#FFFFFF",
  "BOGEY UTILITAIRES": "#FFFFFF",
};

export const societyIdToNom: Record<number, string> = {
  1: "JUGAND AUTOS",
  2: "JUGAND AUTOS",
  7: "JUGAND AUTOS",
  8: "JUGAND AUTOS",
  9: "JUGAND AUTOS",
  10: "JUGAND AUTOS",
  11: "JUGAND AUTOS",
  12: "JUGAND AUTOS",
  13: "JUGAND AUTOS",
  14: "JUGAND AUTOS",
  15: "JUGAND AUTOS",
  16: "JUGAND AUTOS",
  17: "BALLEYDIER 4X4",
  18: "AUTO EVASION",
  20: "POLARIS MONT-BLANC",
  22: "BOGEY UTILITAIRES",
};

export function applySocietePalette(societe: string | undefined | null) {
  if (!societe) return;
  const palette = societePalettes[societe];
  if (!palette) return;
  updatePrimaryPalette(palette);
  const contrast = societeContrastColors[societe];
  if (contrast) {
    document.documentElement.style.setProperty(
      "--p-primary-contrast-color",
      contrast
    );
  }

  // Le manifeste d'installation porte le nom et la couleur de la marque active :
  // le rebâtir ici garantit qu'il suit tout changement de société.
  appliquerManifestePwa(societe);
}

export function applySocietePaletteById(societyId: number | undefined | null) {
  if (societyId == null) return;
  applySocietePalette(societyIdToNom[societyId]);
}

export function useSocietePalette() {
  // Suit la société active sélectionnée dans le header (re-branding au changement),
  // et non plus la société figée de l'utilisateur connecté.
  const selectedSociete = computed(() => store.state.domain.societe);
  watch(selectedSociete, applySocietePalette, { immediate: true });
}
